// extracted by css-extract-rspack-plugin
export default {"switcher":"mj5gq","promo_list":"UZbaF","promoList":"UZbaF","appear":"nENNP"};